import { AssetType } from '@packages/models/api';
import { IAsset } from '../AssetViewerModal';
import { isRenderableImage } from '@web/utils/is-renderable-image';

export type ViewerName = 'image' | 'video' | 'unsupported';

interface ViewerRegistration {
    name: ViewerName;
    canHandle: (asset: IAsset) => boolean;
}

const viewerRegistry: ViewerRegistration[] = [
    {
        name: 'image',
        canHandle: (asset) => canHandleImage(asset),
    },

    {
        name: 'video',
        canHandle: (asset) => asset.assetType === AssetType.Video,
    },
];

export function resolveViewerName(asset: IAsset): ViewerName {
    const match = viewerRegistry.find((viewer) => viewer.canHandle(asset));
    return match?.name ?? 'unsupported';
}

function canHandleImage(asset: IAsset): boolean {
    if (asset.assetType === AssetType.Image) {
        return true;
    }
    return isRenderableImage(asset.contentType, asset.name);
}
